module.exports = __webpack_public_path__ + "static/img/introductionTitle.c8c5b2c8.png";